<script>

  //const serverSrc= `${document.location.protocol}//bam.jcdecauxchina.com.cn/api`;
  //const serverSrc = 'http://localhost:8000/api';
  //const serverSrc = 'https://bam-staging.jcdecauxchina.com.cn/api'
  //const serverSrc = 'https://bam.jcdecauxchina.com.cn/api'
  //const serverSrc = 'https://alb-cnaws1ap0014-987026832.cn-north-1.elb.amazonaws.com.cn/api'
  
    // 自动识别运行环境
  const isLocalhost = document.location.hostname === 'localhost' 
                     || document.location.hostname === '127.0.0.1';
  
  // 根据环境自动选择 API 地址
  const serverSrc = isLocalhost 
    ? '/api'                          // 本地开发
    : `${document.location.protocol}//${document.location.host}/api`;  // 华为云(生产/测试自动适配)
  
  
  const token = '12345678';
  const hasEnter = false;
  const userSite = "中国钓鱼岛";
  const VERSION = '2.1.1';
  const VERSION_NANJING = '2.1';
  const VERSION_WUHAN = '2.1';
  
  const gaodeCityDict = {
    "Nanjing" : "南京",
    "Wuhan" : "武汉",
    "Shenzhen" : "深圳",
    "Chongqing" : "重庆",
    "Chengdu" : "成都",
    "Shanghai" : "上海",
  }
  
  export default {
    token, //用户token身份
    userSite, //用户地址
    serverSrc, //服务器地址
    hasEnter, //用户登录状态
    VERSION,
    VERSION_NANJING,
    VERSION_WUHAN,
    gaodeCityDict
  }
</script>

<style>
</style>
